export class RefugeData {
    static id = 'id';
    static objectname = 'name';
    static email = 'email';
    static location = 'location';
    static shortDescription = 'short_text';
    static longDescription = 'long_text';
    //URL
    static logo = 'logo';
    static phone = 'phone';
    static socialMedia = 'social';
    static default_media = 'default_social';

    // TODO: Pasarlo a un metodo toObject, para retornar un objecto
}